import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  CheckSVTStatus, CustomerData, RsaInterface, ServiceHistoryDetailInterface,
  StartStopSVT, TransactionInterface, TripDetailInterface, VehicleDashboardInterface,
  VinEngineData
} from 'src/app/core/models/customer-details';
import { environment } from '../../../environments/environment';

import { HttpService } from './http-service';



@Injectable({
  providedIn: 'root'
})
export class CustomerDetailsService {


  public searchResults: Array<any> = [];
  public callmeResults: Array<any> = [];
  public callbackResults: Array<any> = [];

  public seachKey: any = '';
  public customerId;
  vinNumber: string;
  primaryMobileNo: any;
  mobileNo: any;
  secondaryContactDetails: any[];


  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  // getCustomerDetails(vinEngineSet: VinEngineData): Observable<any> {

  //   const url = environment.apiUrl + environment.service.customerDetails;

  //   console.log('inside get customer details');
  //   console.log('ENo:' + vinEngineSet.engineNumber);
  //   console.log('VNo:' + vinEngineSet.vinNumber);
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       refreshToken: localStorage.getItem('refreshToken'),
  //       engineNumber: vinEngineSet.engineNumber,
  //       vinNumber: vinEngineSet.vinNumber,
  //       deliteId: localStorage.getItem('userId')
  //     })
  //   };

  //   return this.http.get(url, httpOptions).pipe(
  //     map((res: Response) => {
  //       return res || {};
  //     }),
  //     catchError(this.errorMgmt)
  //   );
  // }


  // get Customer List

  getCustomeList(data): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.getCustomerList;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vinNumber: data.vinNumber,
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    return this.http.get(url, httpOptions).pipe(map((returnData: any) => {
      console.log(returnData);
      return returnData;
    }), catchError(this.errorMgmt));
  }
  getAtntList(data): Observable<any> {
    const url = environment.apiUrl + environment.atnt.getatntDetails;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        refreshToken: localStorage.getItem('refreshToken') || '',
        vinNumber: data.vinNumber,
      
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    return this.http.get(url, httpOptions).pipe(map((returnData: any) => {
      console.log(returnData);
      return returnData;
    }), catchError(this.errorMgmt));
  }
  getCustomerData(data): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.getCustomerData;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vinNumber: data.vinNumber,
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    console.log("httpOptions", httpOptions)
    return this.http.get(url, httpOptions).pipe(map((returnData: any) => {
      console.log(returnData);
      return returnData;
    }), catchError(this.errorMgmt));
  }
  getLetData(data): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.getLetData;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vinNumber: data.vinNumber,
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    console.log("httpOptions", httpOptions)
    return this.http.get(url, httpOptions).pipe(map((returnData: any) => {
      console.log(returnData);
      return returnData;
    }), catchError(this.errorMgmt));
  }
  deleteUser(data): Observable<any> {
    const url = environment.apiUrl + environment.ownershipService.deleteUser;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    console.log("httpOptions", httpOptions)
    return this.http.post(
      url,
      JSON.stringify(data),
      httpOptions).pipe(
        map((res: Response) => {
          return res || {};
        }),
        catchError(this.errorMgmt)
      );
  }

  // NotifyUser
  notifyUser(data) {
    const url = environment.apiUrl + environment.supportPortal.notifyUser;
    return this.httpService.postWithRefershToken(url, data).pipe(map((returnData: any) => {
      console.log(returnData);
      return returnData;
    }), catchError(this.errorMgmt));
  }

  // get Customer call me List

  callmeList(data): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.callmeList;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''

      })
    };
    return this.http.get(url, httpOptions).pipe(map((returnData: any) => {
      console.log(returnData);
      return returnData;
    }), catchError(this.errorMgmt));
  }

  getCallBackOption(data): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.getCallbackDetails;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    return this.http.get(url, httpOptions).pipe(map((returnData: any) => {
      console.log(returnData);
      return returnData;
    }), catchError(this.errorMgmt));
  }

  // update call me List

  callmeListUpdate(data): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.callmeListUpdate;
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     refreshToken: localStorage.getItem('refreshToken')
    //   })
    // };
    return this.httpService.postWithRefershToken(url, data).pipe(map((returnData: any) => {
      console.log(returnData);
      return returnData;
    }), catchError(this.errorMgmt));
  }

  callbackListUpdate(data): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.updateCallback;
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     refreshToken: localStorage.getItem('refreshToken')
    //   })
    // };
    return this.httpService.postWithRefershToken(url, data).pipe(map((returnData: any) => {
      console.log(returnData);
      return returnData;
    }), catchError(this.errorMgmt));
  }


  // getMapScreenCustomerDetails-------------------------------------------------------------------------

  getMapCustomerDetails(data): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.getCustomerDetails;
    console.log('vinNumber:' + data.vinNumber);
    return this.httpService.postWithRefershToken(url, data).pipe(map((returnData: any) => {
      return returnData;
    }), catchError(this.errorMgmt));
  }

  getOpenTicketsCrm(openTicketsData: {
    vinNumber: string; deliteId: string;
  }): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.getOpenTicketsCrm;
    const httpOptions = {
      headers: new HttpHeaders({
        refreshToken: localStorage.getItem('refreshToken'),
        vinNumber: openTicketsData.vinNumber,
        deliteId: openTicketsData.deliteId
      })
    };
    return this.http.get(url, httpOptions).pipe(map((returnData: any) => {
      return returnData;
    }), catchError(this.errorMgmt));
  }


  getVehicleLocation(data: { vinNumber: string; }): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.getVehicleLocation;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vinNumber: data.vinNumber,
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    return this.http.get(url, httpOptions).pipe(map((returndata: any) => {
      return returndata;
    }), catchError(this.errorMgmt));
  }



  // getNearByLocationsData------------------------------------------------------------------
  getNearByLocationsData(nearByFormData: { vinNumber: string;}): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.getNearByLocationsData;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vinNumber: nearByFormData.vinNumber,
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    return this.http.get(url, httpOptions).pipe(map((data: any) => {
      console.log(data);
      return data;
    }), catchError(this.errorMgmt));
  }

  // getSVTDetails-----------------------------------------------------------------------------

  getSVTDetails(svtDetails): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.getSVTDetails;
    return this.httpService.postWithRefershToken(url, svtDetails).pipe(map((data: any) => {
      console.log(data);
      return data;
    }), catchError(this.errorMgmt));
  }

  createCallBackDetails(data): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.createCallback;
    return this.httpService.postWithRefershToken(url, data).pipe(map((returnData: any) => {
      console.log(returnData);
      return returnData;
    }), catchError(this.errorMgmt));
  }

  // startStopSVTDetails-----------------------------------------------------------------------------

  startStopSVT(startStopSvt: StartStopSVT): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.startStopSVT;
    return this.httpService.postWithRefershToken(url, startStopSvt).pipe(map((data: any) => {
      console.log(data);
      return data;
    }), catchError(this.errorMgmt));
  }


  // checkSVTStatus-----------------------------------------------------------------------------

  checkSVTStatus(checkSVTStatus: CheckSVTStatus): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.checkSVTStatus;
    return this.httpService.postWithRefershToken(url, checkSVTStatus).pipe(map((data: any) => {
      console.log(data);
      return data;
    }), catchError(this.errorMgmt));
  }

  // getDashboardData-------------------------------------------------------------------------

  getVehicleDashboardDetails(vehicleDashDetails: VehicleDashboardInterface): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.getDashboardDetails;
    // console.log("vinNumber:" + vehicleDashDetails.vinNumber);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vinNumber: vehicleDashDetails.vinNumber,
        productOwnId: vehicleDashDetails.productOwnId,
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    return this.http.get(url, httpOptions).pipe(map((data: any) => {
      // return this.httpService.postWithRefershToken(url, vehicleDashDetails).pipe(map((data: any) => {
      console.log(data);
      return data;
    }), catchError(this.errorMgmt));
  }

  // getTripDetails-------------------------------------------------------------------------

  getTripDetails(tripDetails: TripDetailInterface): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.getTripDetails;
    // console.log("vinNumber:" + tripDetails.vinNumber);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vinNumber: tripDetails.vinNumber,
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    return this.http.get(url, httpOptions).pipe(map((data: any) => {
      console.log(data);
      return data;
    }), catchError(this.errorMgmt));
  }

  // getServiceHistoryDetails-------------------------------------------------------------------------

  getServiceHistoryDetails(ServiceHistoryDetails: ServiceHistoryDetailInterface): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.getServiceHistoryDetails;
    // console.log("vinNumber:" + ServiceHistoryDetails.vinNumber);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vinNumber: ServiceHistoryDetails.vinNumber,
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    return this.http.get(url, httpOptions).pipe(map((data: any) => {
      console.log(data);
      return data;
    }), catchError(this.errorMgmt));
  }
  // getRsaDetails-------------------------------------------------------------------------

  getRsaDetails(RsaDetails: RsaInterface): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.getRsaDetails;
    // console.log("vinNumber:" + RsaDetails.vinNumber);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vinNumber: RsaDetails.vinNumber,
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    return this.http.get(url, httpOptions).pipe(map((data: any) => {
      console.log(data);
      return data;
    }), catchError(this.errorMgmt));
  }

  // getTransactionDetails-------------------------------------------------------------------------

  getTransactionDetails(transDetails: TransactionInterface): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.getTransactionDetails;
    // console.log("vinNumber:" + transDetails.vinNumber);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vinNumber: transDetails.vinNumber,
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    return this.http.get(url, httpOptions).pipe(map((data: any) => {
      console.log(data);
      return data;
    }), catchError(this.errorMgmt));
  }

  // getFuelLogDetails-------------------------------------------------------------------------

  getFuelLogDetails(transDetails: TransactionInterface): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.getFuelLogDetails;
    // console.log("vinNumber:" + transDetails.vinNumber);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vinNumber: transDetails.vinNumber,
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    return this.http.get(url, httpOptions).pipe(map((data: any) => {
      console.log(data);
      return data;
    }), catchError(this.errorMgmt));
  }

  getInsuranceDetails(transDetails: TransactionInterface): Observable<any> {
    const url = environment.apiUrl + environment.activationPortal.getInsuranceDetails;
    // console.log("vinNumber:" + transDetails.vinNumber);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vinNumber: transDetails.vinNumber,
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };
    return this.http.get(url, httpOptions).pipe(map((data: any) => {
      return data;
    }), catchError(this.errorMgmt));
  }


  submitCustomersDetails(dataPost: CustomerData): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        refreshToken: localStorage.getItem('refreshToken') || '',
        engineNumber: localStorage.getItem('engineNumber') || '',
        vinNumber: localStorage.getItem('vinNumber') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };

    const urlData = environment.apiUrl + environment.activationPortal.activateCustomer;
    return this.http.post(
      urlData,
      JSON.stringify(dataPost),
      httpOptions).pipe(
        map((res: Response) => {
          return res || {};
        }),
        catchError(this.errorMgmt)
      );
  }
  sendSms() {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        refreshToken: localStorage.getItem('refreshToken') || '',
        deliteId: localStorage.getItem('userId') || ''
      })
    };

    const urlData = environment.apiUrl + environment.activationPortal.sendSms;
    return this.http.post(
      urlData,
      JSON.stringify({
        mobileNo: localStorage.getItem('mobileNo'),
        message: 'Welcome to Honda Family, Activation of Honda Connect application is success. Use the the below link to download the application. https://www.hondacarindia.com/ \n- Honda Cars India Ltd.'
      }),
      httpOptions).pipe(
        map((res: Response) => {
          console.log('Sms sent: ' + res);
          return res || {};
        }),
        catchError(this.errorMgmt)
      );
  }

  // Error handling
  errorMgmt(error: HttpErrorResponse) {
    let errorMessage: any;
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = error;
    }
    return throwError(errorMessage);
  }

  processTrips(payload: {
    vinNumber: string; startDate: string; endDate: string;
  }): Observable<any> {
    let sendHttpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "Authorization": environment.EiInterface.authId,
        "vendorType": 'other'
      })
    };
    let body = {
      "vinNumber": payload.vinNumber,
      "startDate": payload.startDate,
      "endDate": payload.endDate
    }
    const url = environment.EiInterface.url + environment.eiInterface.processTrip;
    return this.http
      .post(url, body, sendHttpOptions)
      .pipe(catchError(this.errorMgmt));
  }
}
